import {inject, Injectable, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class VimeoService {
  private sanitizer = inject(DomSanitizer);


  public getVimeoIframeURL(vimeoId: string, loop: boolean|undefined): string {
    let url = `https://player.vimeo.com/video/${vimeoId}?texttrack=da`;
    if (loop !== false) {
      url += '&loop=1';
    }
    return url;
  }

  public getVimeoElement(vimeoId: string | undefined, loop: boolean | undefined, url: string | null = null): HTMLIFrameElement {
    if (!vimeoId && !url) {
      throw new Error('Either vimeoId or url must be provided');
    }
    if (!url && vimeoId) {
      url = this.getVimeoIframeURL(vimeoId, loop);
    }
    if (!url) {
      throw new Error('No valid URL provided for Vimeo iframe');
    }
    const urlSafe = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(url));
    const iframe = document.createElement('iframe');
    iframe.frameBorder = '0';
    iframe.allowFullscreen = true;
    iframe.setAttribute('src', urlSafe as string);
    return iframe;
  }

}
